import { render, staticRenderFns } from "./SearchFinalidadComponent.vue?vue&type=template&id=6a00ef2a&scoped=true"
import script from "./SearchFinalidadComponent.vue?vue&type=script&lang=js"
export * from "./SearchFinalidadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a00ef2a",
  null
  
)

export default component.exports